<template>
    <div class="content3d--area relative" style="z-index:2; overflow:hidden;">
        <div class="b-container relative" style="padding-top:20px; padding-bottom:20px;">
            <div class="column v-center center mb-xxl">
                <div class="row">
                    <div class="h1 ml-xxl">我们的服务</div>
                    <div class="relative ml-md" style="width:44px; height:44px;">
                        <img :src="PlusRedIcon" style="width:44px; height:44px; position:absolute; top:-12px; left:0;" />
                    </div>
                </div>
                <div class="t3 secondary" style="text-transform: uppercase; letter-spacing:.1em;">
                    Services
                </div>
            </div>
            <div v-if="clientWidth >= 992">
                <div class="container-list">
                    <div :class="[index == 2 ? 'container-list-item-end' : 'container-list-item']"
                        v-for="(item, index) in software31">
                        <div style="margin: 20px;">
                            <div class="row center jump-icon">
                                <img :src="item.cover" class="subject-index image-icon" />
                            </div>
                            <div class="row center h4 mb-sm pr-lg title" style="margin-top: 20px; color:#000;">
                                {{ item.title }}
                            </div>
                            <div class="row center t8 secondary pr-lg summary" style="color:#222;">
                                {{ item.summary }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-list-bottom">
                    <div :class="[index == 2 ? 'container-list-item-end' : 'container-list-item']"
                        v-for="(item, index) in software32">
                        <div style="margin: 20px;">
                            <div class="row center jump-icon">
                                <img :src="item.cover" class="subject-index image-icon" />
                            </div>
                            <div class="row center h4 mb-sm pr-lg title" style="margin-top: 20px; color:#000;">
                                {{ item.title }}
                            </div>
                            <div class="row center t8 secondary pr-lg summary" style="color:#222;">
                                {{ item.summary }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="clientWidth < 992" style="margin-top: -20px;">
                <div class="container-list">
                    <div :class="[index == 1 ? 'container-list-item-end' : 'container-list-item']"
                        v-for="(item, index) in software21">
                        <div style="margin: 0px 20px;">
                            <div class="row center phone-icon">
                                <img :src="item.cover" class="subject-index phone-image-icon" />
                            </div>
                            <div class="row center h4 mb-sm pr-lg title" style="margin-top: 20px; color:#000;">
                                {{ item.title }}
                            </div>
                            <div class="t6" v-html="item.summary">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-list">
                    <div :class="[index == 1 ? 'container-list-item-end' : 'container-list-item']"
                        v-for="(item, index) in software22">
                        <div style="margin: 0px 20px;">
                            <div class="row center phone-icon">
                                <img :src="item.cover" class="subject-index phone-image-icon" />
                            </div>
                            <div class="row center h4 mb-sm pr-lg title" style="margin-top: 20px; color:#000;">
                                {{ item.title }}
                            </div>
                            <div class="t6" v-html="item.summary">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-list-bottom">
                    <div :class="[index == 1 ? 'container-list-item-end' : 'container-list-item']"
                        v-for="(item, index) in software23">
                        <div style="margin: 0px 20px;">
                            <div class="row center phone-icon">
                                <img :src="item.cover" class="subject-index phone-image-icon" />
                            </div>
                            <div class="row center h4 mb-sm pr-lg title" style="margin-top: 20px; color:#000;">
                                {{ item.title }}
                            </div>
                            <div class="t6" v-html="item.summary">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {
    PlusRedIcon,
    iconSer1,
    iconSer2,
    iconSer3,
    iconSer4,
    iconSer5,
    iconSer6,
} from '@/constants/pics';

export default {
    name: 'content3d',

    props: [],

    components: {},

    data() {
        return {
            PlusRedIcon,
            clientWidth: 0,
            software31: [
                {
                    cover: iconSer1,
                    title: '专业服务',
                    summary:
                        '我们对传统的业务到云业务提供迁移、运维、成本优化、开发等全方位的服务',
                }, {
                    cover: iconSer2,
                    title: '云计算服务转售',
                    summary:
                        '我们提供多云厂商的云计算转售业务',
                }, {
                    cover: iconSer3,
                    title: '全球渠道业务',
                    summary:
                        '我们拓展云厂商 CloudFront全球渠道业务并发展敏捷云生态圈',
                },
            ],
            software32: [
                {
                    cover: iconSer4,
                    title: '信息安全合规',
                    summary:
                        '我们提供数据安全托管、信息合规Certification、数据保护、信息安全方案代理服务',
                }, {
                    cover: iconSer5,
                    title: '培训业务',
                    summary:
                        '我们依托云厂商的产品，对云厂商 Certification 提供一整套从培训、考试以及后续深入学习的完整服务',
                }, {
                    cover: iconSer6,
                    title: '技术支持',
                    summary:
                        '我们提供云厂商商业级技术支持、企业级技术支持及第三方解决方案',
                },
            ],
            software21: [
                {
                    cover: iconSer1,
                    title: '专业服务',
                    summary:
                        '我们对传统的业务到云业务提供迁移、运维、成本优化、开发等全方位的服务',
                }, {
                    cover: iconSer2,
                    title: '云计算服务转售',
                    summary:
                        '我们提供多云厂商的云计算转售业务',
                }
            ],
            software22: [{
                cover: iconSer3,
                title: '全球渠道业务',
                summary:
                    '我们拓展云厂商 CloudFront全球渠道业务并发展敏捷云生态圈',
            },
            {
                cover: iconSer4,
                title: '信息安全合规',
                summary:
                    '我们提供数据安全托管、信息合规Certification、数据保护、信息安全方案代理服务',
            }
            ],
            software23: [
                {
                    cover: iconSer5,
                    title: '培训业务',
                    summary:
                        '我们依托云厂商的产品，对云厂商 Certification 提供一整套从培训、考试以及后续深入学习的完整服务',
                }, {
                    cover: iconSer6,
                    title: '技术支持',
                    summary:
                        '我们提供云厂商商业级技术支持、企业级技术支持及第三方解决方案',
                },
            ],
        };
    },

    computed: {
    },

    created() { },

    mounted() {
        const { clientWidth } = document.documentElement;
        this.clientWidth = clientWidth;
        let resizeTag = true;
        window.addEventListener('resize', () => {
            if (resizeTag) {

                // 02
                const { clientWidth } = document.documentElement;
                this.clientWidth = clientWidth;

                resizeTag = false;
                setTimeout(() => {
                    resizeTag = true;
                }, 100);
            }
        });
    },

    activated() { },

    deactivated() { },

    methods: {

    },
};
</script>

<style scoped lang="scss">
@import '~@/stylesheets/modules/all';

.content3d-area {
    background: linear-gradient(to right, rgba(255, 51, 85, 1) 0%, rgba(241, 53, 54, 1) 100%);
    overflow: hidden;
}

// swiper-item
.swiper-container {
    width: 100%;
    height: 100%;
}

.swiper-slide {
    // width: 320px;
    // height: 380px;
    // text-align: center;
    font-size: 18px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;

    position: relative;
}

.swiper-slide:after {
    content: '';
    position: relative;
    // margin-top: 133.33%;
}

.swiper-next,
.swiper-prev {
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 10;
    cursor: pointer;
    color: #333;
    width: 64px;
    height: auto;
    border-radius: 12px;
    border-radius: 0;
    will-change: transform;
    transition: all 300ms;
    outline: none;
}

.swiper-next:hover,
.swiper-prev:hover {
    width: 64px;
}

.swiper-next {
    right: -64px;
    left: auto;
    border-radius: 0;
    border-right: 0;
}

.swiper-prev {
    left: -64px;
    right: auto;
    border-radius: 0;
    border-left: 0;
}

//
//
//
a.more {
    color: #666;
    text-decoration: none;
}

// content3d-cover
.content3d-cover {
    background: rgba(127, 127, 127, 0.1);
    overflow: hidden;
}

.content3d-cover:after {
    content: '';
    position: relative;
    margin-top: 100%;
}

.content3d-cover a {
    display: block;
    width: 240px;
    height: 380px;
}

@media (max-width: 991px) {
    .content3d-title {
        padding: 0 15px;
    }

    .h1 {
        font-size: 24px;
    }

    .scroll-wrap {
        width: 100%;
        height: auto;
        overflow-x: auto;
        overflow-y: hidden;
    }

    .scroll-wrap .b-row {
        width: 1085px;
    }

    .b-container {
        padding-left: 0;
        padding-right: 0;
    }

    .b-row {
        margin-left: 0;
        margin-right: 0;
    }

    // .company-item-wrap {
    //     flex: 0 0 320px;
    // }
    //
    // .company-item {
    //     width: 240px;
    //     height: 380px;
    // }

    a.more {
        font-size: 16px;
    }

    .title {
        font-size: 16px;
    }

    .summary {
        font-size: 16px;
    }
}

.swiper-item {
    overflow: hidden;
}

.swiper-item .desc {
    will-change: transform;
    transition: all 300ms;
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 80px;
    z-index: 3;
    background: rgba(255, 255, 255, 0.88);
    text-align: left;
}

.swiper-item.hover .desc {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 196px;
    z-index: 3;
    color: #fff;
    // background: linear-gradient(to bottom, rgba(255, 51, 85, 0.8) 0%, rgba(241, 53, 54, 0.9) 100%);
    background: rgba(0, 0, 0, 0.5);
}

.swiper-button-disabled img {
    opacity: 0.38;
}

.lightbox {
    display: none;
}

.lightbox.display {
    display: block;
}

.swiper-container-wrap {
    margin-left: -15px;
    margin-right: -15px;
}

@media (max-width: 991px) {
    .swiper-container-wrap {
        margin-left: 0;
        margin-right: 0;
    }
}

//
.swiper-pagination .swiper-pagination-bullet-active {
    background: #ffffff !important;
}

//
//
//
a.more {
    color: #666;
    text-decoration: none;
}

.software-list a {
    text-decoration: none;
    color: #555;
}

.software-cover {
    background: rgba(127, 127, 127, 0.1);
    overflow: hidden;
}

.software-cover:after {
    content: '';
    position: relative;
    margin-top: 62.5%;
}

.software-cover a {
    display: block;
    width: 100%;
    height: 100%;
}

// slideCard_image
.card-item a:hover .slideCard_image:before {
    -webkit-transform: scaleX(1);
    -ms-transform: scaleX(1);
    transform: scaleX(1);
    -webkit-transform-origin: left;
    -ms-transform-origin: left;
    transform-origin: left;
    -webkit-transition: -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1),
        -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.slideCard_image {
    -webkit-transition-property: opacity;
    transition-property: opacity;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    opacity: 1;

    position: relative;
    overflow: hidden;
}

.slideCard_image:before {
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    display: block;
    // background: linear-gradient(to right, rgba(255, 51, 85, 0.38) 0%, rgba(241, 53, 54, 0.2) 100%);
    // background: linear-gradient(to right, rgba(0, 0, 0, 0.38) 0%, rgba(0, 0, 0, 0.2) 100%);
    opacity: 1;
    -webkit-transform-origin: right;
    -ms-transform-origin: right;
    transform-origin: right;
    -webkit-transform: scaleX(0);
    -ms-transform: scaleX(0);
    transform: scaleX(0);
    -webkit-transition: -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
    transition: transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1),
        -webkit-transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.card-item {
    padding: 0 15px;
}

.card-item a {
    text-decoration: none;
}

.card-item a .title {
    color: #000;
}

.card-item a .summary {
    color: #666;
}

.container-list {
    display: flex;
    border-bottom: 1px solid #f8f8f8;
}

.container-list-bottom {
    display: flex;
}

.container-list-item {
    flex: 1;
    padding: 30px 0px;
    border-right: 1px solid #f8f8f8;
    /* 设置右分界线，可以更改颜色和宽度 */
}

.container-list-item-end {
    flex: 1;
    padding: 30px 0px;
}

.container-list-icon {
    height: 0.6rem;
    margin-bottom: 0.3rem;
    transition: all ease .3s 0s;
    -webkit-transition: all ease .3s 0s;
}

.jump-icon {
    height: 50px;
}

.phone-icon {
    height: 40px;
}

.image-icon {
    height: 50px;
    width: 50px;
}

.phone-image-icon {
    height: 40px;
    width: 40px;
}

.subject-index:focus,
.subject-index:hover {
    margin-top: -10px;
}
</style>
